module.exports = __webpack_public_path__ + "zvetseni-prsou_62_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_62_before.jpg
// module id = 1358
// module chunks = 0